import React from 'react';
import Typography from '@mui/material/Typography';
import { ThemeProvider } from '@mui/material/styles';
import theme from './typoTheme';

import { TypographyVariant, TypographyComponent } from '@src/utils/types';

interface IProps {
  variant: TypographyVariant;
  component: TypographyComponent;
  style?: any;
  cName?: string;
  onClick?: any;
  children: any;
}

// style: 원하는 style
// component: 렌더링 되어야하는 HTML태그
const CustomTypography = ({ variant, style, component, cName, onClick, children, ...rest }: IProps) => {
  let customStyle = {
    ...style
  };

  return (
    <ThemeProvider theme={theme}>
      <Typography
        className={`custom-typo ${cName ? cName : ''}`}
        variant={variant}
        component={component}
        sx={customStyle}
        onClick={onClick}
        {...rest}>
        {children}
      </Typography>
    </ThemeProvider>
  );
};

export default CustomTypography;
